import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-7 14h-2V9h-2V7h4v10z"
}), 'LooksOneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LooksOneSharp.js
// module id = 4730
// module chunks = 2